import * as React from "react";

const Boolean = (props: any) => (
  <svg width={20} height={20} viewBox="0 0 20 20" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M3 3h14v14H3z" />
      <path
        d="M4.645 5.1h.962v5.498h-.962V5.1zm4.31 1.97h.84l-2.21 5.759h-.84l2.21-5.76zm3.862 2.884c-.293 0-.546.06-.759.178a1.487 1.487 0 0 0-.52.473 2.136 2.136 0 0 0-.296.674 3.103 3.103 0 0 0 0 1.54c.064.251.163.476.297.674.133.197.306.355.52.473.212.118.465.177.758.177.292 0 .545-.059.758-.177.213-.118.387-.276.52-.473.133-.198.232-.423.296-.674a3.103 3.103 0 0 0 0-1.54 2.136 2.136 0 0 0-.296-.674 1.487 1.487 0 0 0-.52-.473 1.541 1.541 0 0 0-.758-.178zm0-.785a2.474 2.474 0 0 1 1.933.855c.225.262.399.567.52.916.12.35.18.719.18 1.109 0 .395-.06.767-.18 1.116-.121.35-.295.655-.52.917a2.43 2.43 0 0 1-.828.62 2.593 2.593 0 0 1-1.105.227c-.41 0-.78-.076-1.105-.227a2.43 2.43 0 0 1-.828-.62 2.773 2.773 0 0 1-.52-.917 3.395 3.395 0 0 1-.18-1.116c0-.39.06-.76.18-1.109.121-.349.294-.654.52-.916a2.474 2.474 0 0 1 1.933-.855z"
        fill="#7B838C"
      />
    </g>
  </svg>
);

export default Boolean;

